import { render, staticRenderFns } from "./RegistrosAssociados.vue?vue&type=template&id=40733908&scoped=true&"
import script from "./RegistrosAssociados.vue?vue&type=script&lang=js&"
export * from "./RegistrosAssociados.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosAssociados.vue?vue&type=style&index=0&id=40733908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40733908",
  null
  
)

export default component.exports